module.exports = __webpack_public_path__ + "img/CCGrayContent.80659a60.jpg";